import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from "@material-ui/core";
import I18nText from "../../../elements/I18nText";

const AdvancedFilters = ({
  filters,
  onFilterChange,
  options = {},
  contentTypes = [],
  deviceStatuses = []
}) => {
  const {
    mediumOptions = contentTypes,
    statusOptions = deviceStatuses
  } = options;

  return (
    <Box display="flex" flexDirection="column" gridGap={16} mt={2}>
      <FormControl variant="outlined" size="small" fullWidth margin="dense">
        <InputLabel id="medium-label">Medium</InputLabel>
        <Select
          labelId="medium-label"
          value={filters.medium}
          onChange={e => onFilterChange("medium", e.target.value)}
          label="Medium"
        >
          <MenuItem value="">
            <em>
              <I18nText>topbar.filter.any</I18nText>
            </em>
          </MenuItem>
          {mediumOptions.map(opt => (
            <MenuItem key={String(opt.value ?? opt)} value={opt.value ?? opt}>
              <I18nText>{`sensors.contentTypes.${opt}`}</I18nText>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small" fullWidth margin="dense">
        <InputLabel id="status-label">Status</InputLabel>
        <Select
          labelId="status-label"
          value={filters.status}
          onChange={e => onFilterChange("status", e.target.value)}
          label="Status"
        >
          <MenuItem value="">
            <em>
              <I18nText>topbar.filter.any</I18nText>
            </em>
          </MenuItem>
          {statusOptions.map(opt => (
            <MenuItem key={String(opt.value ?? opt)} value={opt.value ?? opt}>
              {opt.label ?? opt}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default AdvancedFilters;
